import React, { createContext, useState } from "react";
import additionalLocationService from "../services/additionalLocationService";

const initialState = {
  loading: false,
  additionalLocations: [],
};

const additionalLocationContext = createContext();

const AdditionalLocationContextProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const getAllAdditionalLocations = async () => {
    setState({ ...state, loading: true });
    const data = await additionalLocationService.getAll();
    setState({ additionalLocations: data, loading: false });
  };

  const value = { state, setState, getAllAdditionalLocations };
  return (
    <additionalLocationContext.Provider value={value}>
      {children}
    </additionalLocationContext.Provider>
  );
};

const useAdditionalLocationContext = () => {
  const context = React.useContext(additionalLocationContext);
  if (context === undefined) {
    throw new Error(
      "additionalLocationContext must be used within a AdditionalLocationContextProvider"
    );
  }
  return context;
};

export { AdditionalLocationContextProvider, useAdditionalLocationContext };
